const offlineSession = {
  fr: {
    offlineSessionExpired: 'Session expirée. Vos conversations enregistrées restent disponibles.',
    offlineSessionReader: 'Hors connexion — vous pouvez relire vos échanges. Les nouvelles réponses nécessitent Internet.',
    offlineSessionRetry: 'Réessayer la connexion', offlineSessionSignIn: 'Se reconnecter',
    offlineSessionLogoutWarning: 'Des échanges, notes ou documents ne sont pas encore synchronisés. Se déconnecter supprimera leurs copies sur ce téléphone. Continuer ?',
    offlineSessionLogoutError: 'Impossible de supprimer les copies locales. La déconnexion a été annulée pour préserver vos données.',
  },
  en: {
    offlineSessionExpired: 'Session expired. Your saved conversations remain available.',
    offlineSessionReader: 'Offline — you can read your conversations. New answers require Internet.',
    offlineSessionRetry: 'Retry connection', offlineSessionSignIn: 'Sign in again',
    offlineSessionLogoutWarning: 'Some conversations, notes or files have not synced yet. Signing out will remove their copies from this phone. Continue?',
    offlineSessionLogoutError: 'Local copies could not be removed. Sign-out was cancelled to preserve your data.',
  },
  es: {
    offlineSessionExpired: 'La sesión ha caducado. Tus conversaciones guardadas siguen disponibles.',
    offlineSessionReader: 'Sin conexión: puedes leer tus conversaciones. Las nuevas respuestas requieren Internet.',
    offlineSessionRetry: 'Reintentar conexión', offlineSessionSignIn: 'Volver a iniciar sesión',
    offlineSessionLogoutWarning: 'Algunas conversaciones, notas o archivos aún no se han sincronizado. Cerrar sesión eliminará sus copias de este teléfono. ¿Continuar?',
    offlineSessionLogoutError: 'No se pudieron eliminar las copias locales. Se canceló el cierre de sesión para conservar tus datos.',
  },
  pt: {
    offlineSessionExpired: 'A sessão expirou. Suas conversas salvas continuam disponíveis.',
    offlineSessionReader: 'Sem conexão: você pode ler suas conversas. Novas respostas precisam de Internet.',
    offlineSessionRetry: 'Tentar conexão novamente', offlineSessionSignIn: 'Entrar novamente',
    offlineSessionLogoutWarning: 'Algumas conversas, notas ou arquivos ainda não foram sincronizados. Sair removerá as cópias deste telefone. Continuar?',
    offlineSessionLogoutError: 'Não foi possível remover as cópias locais. A saída foi cancelada para preservar seus dados.',
  },
  vi: {
    offlineSessionExpired: 'Phiên đăng nhập đã hết hạn. Bạn vẫn có thể đọc các cuộc trò chuyện đã lưu.',
    offlineSessionReader: 'Ngoại tuyến — bạn có thể đọc các cuộc trò chuyện. Câu trả lời mới cần kết nối Internet.',
    offlineSessionRetry: 'Thử kết nối lại', offlineSessionSignIn: 'Đăng nhập lại',
    offlineSessionLogoutWarning: 'Một số cuộc trò chuyện, ghi chú hoặc tệp chưa đồng bộ. Đăng xuất sẽ xóa bản sao trên điện thoại này. Tiếp tục?',
    offlineSessionLogoutError: 'Không thể xóa các bản sao trên điện thoại. Đã hủy đăng xuất để bảo toàn dữ liệu của bạn.',
  },
  hi: {
    offlineSessionExpired: 'सत्र समाप्त हो गया है। आपकी सहेजी गई बातचीत अभी भी उपलब्ध हैं।',
    offlineSessionReader: 'ऑफ़लाइन — आप अपनी बातचीत पढ़ सकते हैं। नए जवाबों के लिए इंटरनेट चाहिए।',
    offlineSessionRetry: 'कनेक्शन फिर आज़माएँ', offlineSessionSignIn: 'फिर से साइन इन करें',
    offlineSessionLogoutWarning: 'कुछ बातचीत, नोट्स या फ़ाइलें अभी सिंक नहीं हुई हैं। साइन आउट करने से फ़ोन पर उनकी प्रतियाँ हट जाएँगी। जारी रखें?',
    offlineSessionLogoutError: 'स्थानीय प्रतियाँ हटाई नहीं जा सकीं। आपका डेटा सुरक्षित रखने के लिए साइन आउट रद्द कर दिया गया।',
  },
  ar: {
    offlineSessionExpired: 'انتهت صلاحية الجلسة. لا تزال محادثاتك المحفوظة متاحة.',
    offlineSessionReader: 'دون اتصال — يمكنك قراءة محادثاتك. تتطلب الإجابات الجديدة اتصالاً بالإنترنت.',
    offlineSessionRetry: 'إعادة محاولة الاتصال', offlineSessionSignIn: 'تسجيل الدخول مجدداً',
    offlineSessionLogoutWarning: 'لم تتم مزامنة بعض المحادثات أو الملاحظات أو الملفات بعد. سيؤدي تسجيل الخروج إلى حذف نسخها من هذا الهاتف. هل تريد المتابعة؟',
    offlineSessionLogoutError: 'تعذر حذف النسخ المحلية. تم إلغاء تسجيل الخروج للحفاظ على بياناتك.',
  },
  ur: {
    offlineSessionExpired: 'سیشن ختم ہو گیا ہے۔ آپ کی محفوظ گفتگو اب بھی دستیاب ہیں۔',
    offlineSessionReader: 'آف لائن — آپ اپنی گفتگو پڑھ سکتے ہیں۔ نئے جوابات کے لیے انٹرنیٹ درکار ہے۔',
    offlineSessionRetry: 'کنکشن دوبارہ آزمائیں', offlineSessionSignIn: 'دوبارہ سائن ان کریں',
    offlineSessionLogoutWarning: 'کچھ گفتگو، نوٹس یا فائلیں ابھی مطابقت پذیر نہیں ہوئی ہیں۔ سائن آؤٹ کرنے سے فون پر ان کی نقول حذف ہو جائیں گی۔ جاری رکھیں؟',
    offlineSessionLogoutError: 'مقامی نقول حذف نہیں ہو سکیں۔ آپ کا ڈیٹا محفوظ رکھنے کے لیے سائن آؤٹ منسوخ کر دیا گیا۔',
  },
};
export default offlineSession;
